export const HOUR_RANGE = 2;
export const LEGEND_WIDTH = 174;
export const SUMMARRY_WIDTH = 150;
export const ZINDEX_ORDER = {
    CustomRangeLines: 10,
    CustomRangeLabels: 20,
    Marker: 30
};
